export const getSingleCourseData = (payload?: any) => ({
    type: "@saga/GET_SINGLE_COURSE_DATA",
    payload
});

